export const AUTHORIZATION_SUCCESS = {
    success: true,
    redirect_url: 'https://member.referusnetwork.com/login?integration_session_id=60',
    integration_session_id: 60,
    message: 'Open redirect_url in browser to continue authorization',
};

export const TOKEN_EXCHANGE_SUCCESS = {
    message: 'Access token generated successfully',
    access_token: '<jwt_access_token>',
    token_type: 'Bearer',
    expires_in: 3600,
    refresh_token: '<refresh_token>',
};


export const CREATE_REFERRER_SUCCESS = {
    success: true,
    message: 'You successfully became a referrer for <business_name>.',
};

export const SEND_REFERRAL_SUCCESS_RESPONSE = {
    status: 'success',
    message: 'Referral sent successfully',
    referral_id: 123,
    first_name: 'Jane',
    last_name: 'Doe',
    email: 'jane.doe@example.com',
    mobile_number: '+1234567890',
    referral_status: 'pending',
    created_at: '2024-01-01T12:00:00Z',
};

export const UPDATE_REFERRAL_STATUS_SUCCESS_RESPONSE = {
    success: true,
    data: {
        id: 146,
        sender_id: 181,
        firstName: 'hina',
        lastName: 'dv',
        email: 'hina@yopmail.com',
        mobileNumber: '7410258963',
        businessCode: 'BC000075',
        businessName: 'Rhodes Rose Associates',
        outcome: 'acknowledged',
        paidOffer: 0,
        totalAmountPaid: 0,
        // contactedDate: null,
        isReferUs: false,
        isEmailSent: false,
        isReferrerPaid: false,
        isRead: false,
        comment: 'test',
        hasSpoken: false,
        createdAt: '2026-02-04T11:22:13.000Z',
        updatedAt: '2026-02-04T11:26:14.330Z',
    },
};

export const GET_REWARDS_SUCCESS_RESPONSE = {
    response: [
        {
            key: 1,
            label: 'Amazon Gift Card',
        },
        {
            key: 2,
            label: 'Cash Reward',
        },
    ],
};

export const GET_REFERRALS_SUCCESS_RESPONSE = {
    success: true,
    message: 'Referrals fetched successfully',
    pagination: {
        totalItems: 1,
        totalPages: 1,
        currentPage: 1,
        pageSize: 10,
    },
    data: [
        {
            id: 146,
            sender_id: 181,
            firstName: 'hina',
            lastName: 'dv',
            email: 'hina@yopmail.com',
            mobileNumber: '7410258963',
            businessCode: 'BC000075',
            businessName: 'Rhodes Rose Associates',
            outcome: 'qualified',
            paidOffer: 0,
            totalAmountPaid: 0,
            contactedDate: '2026-02-04T11:30:32.000Z',
            isRead: false,
            isEmailSent: false,
            comment: 'test',
            hasSpoken: false,
            createdAt: '2026-02-04T11:22:13.000Z',
            selfSend: 0,
            sender: {
                firstName: 'jimmy',
                lastName: 'df',
                email: 'jimmy@yopmail.com',
                // contactName: null,
                // BusinessDetails: null,
            },
            rewards: [
                {
                    id: 98,
                    referralId: 146,
                    offerName: 'Test Reward',
                    offerValue: 20,
                    offerType: 'cash',
                    createdAt: '2026-02-04T11:22:13.000Z',
                    updatedAt: '2026-02-04T11:22:13.000Z',
                },
            ],
        },
    ],
};

export const PAY_REFERRAL_RESPONSE = {
    success: true,
    message: 'Paid successfully',
    result: {
        id: 146,
        sender_id: 181,
        firstName: 'hina',
        lastName: 'dv',
        email: 'hina@yopmail.com',
        outcome: 'success',
        paidOffer: 20,
        totalAmountPaid: 20,
        businessCode: 'BC000075',
        businessName: 'Rhodes Rose Associates',
        createdAt: '2026-02-04T11:22:13.000Z',
        updatedAt: '2026-02-04T11:35:06.797Z',
    },
};


export const PAY_REFERRER_RESPONSE = {
    success: true,
    message: 'Paid successfully',
    result: {
        id: 24,
        adminId: 134,
        referrerId: 188,
        amount: 100,
        referralsCount: 1,
        createdAt: '2026-02-04T11:38:23.017Z',
        updatedAt: '2026-02-04T11:38:23.017Z',
    },
};
